module.exports = __webpack_public_path__ + "static/media/g7.c2059388.jpg";